// 下载
var newWindow;
document.querySelectorAll('a[href$="dmg"], a[href$="exe"]').forEach(function(item){
    item.addEventListener('click', function(e){
        if (device_confirm()) { // 判断是否为移动端
            var href = item.getAttribute('href');
            var download_page = '';
            if (href.includes('streambyte-for-music')) {
                download_page = 'https://streambyte.jp/all-music-converter/mobile-download/';
            } else if (href.includes('streambyte-for-video')) {
                download_page = 'https://streambyte.jp/all-video-downloader/mobile-download/';
            } else if (href.includes('amazon-video-downloader')) {
                download_page = 'https://streambyte.jp/amazon-video-downloader/mobile-download/';
            }
            // 打开新窗口并跳转到指定页面
            if (download_page) {
                newWindow = window.open(download_page, '_blank');
                e.preventDefault(); // 阻止默认的点击行为
            }
        }
        // PC 端不做处理，让默认的下载行为执行
    });
});

// 判断设备是否为移动端
function device_confirm() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            return true; // 检测到移动端设备返回 true
        }
    }
    if (window.screen.width < 1024) {
        return true;
    }
    return false; // 未检测到移动端设备返回 false
}